export default "__VITE_ASSET__Dcbmdr9t__"